
import Teleport from 'vue2-teleport';
import { Button, Popover, Drawer, SkeletonItem, Skeleton } from 'element-ui';
import { ClockIcon, ChevronDownIcon, MapPinIcon } from 'vue-feather-icons';
import RelaiPointCard from './RelaiPointCard.vue';
import CarriersHoraire from '../pages/cart/components/CarriersHoraire.vue';
import carriersMixin from '@/mixins/carriersMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import addressMixin from '@/mixins/addressMixin.js';
import { TunnelHelper } from '@/helpers/TunnelHelper.js';
export default {
  mixins: [carriersMixin, cartMixin, addressMixin],
  props: {
    carrier: {
      type: Object,
      required: true,
    },
    carrierType: {
      type: String,
    },
  },
  data() {
    return {
      drawer: false,
      drawerTitle: '',
      direction: 'rtl',
      relayPointSelected: null,
      mapSelected: '',
      pointsClickAndCollectMap: [],
      relayPoints: [],
      relayPointsLoading: false,
      relayPointsFetched: false,
      selected: false,
    };
  },
  computed: {
    activeTab() {
      return this.$store.state.carriers.activeTab;
    },
    getCarrier() {
      return this.cart?.Shipping?.Carrier;
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(newTab) {
        if (newTab === 'RelayPoint' && this.carrierType === 'RelayPoint') {
          this.fetchRelayPoints();
        }
      }
    }
  },
  async mounted() {
    // if (this.carrier?.Addresses) {
    //   this.relayPointSelected = this.carrier?.Addresses[0];
    // }
    // if (this.carrier?.IdCarrier === this.getCarrier?.IdCarrier) {
    //   await this.setCarrier();
    // }

    // if (this.carrier?.IdCarrier === this.getCarrier?.IdCarrier) {
    //   await this.setCarrier();
    // }

    // fetch handling moved to fetchRelayPoints() listener
  },
  methods: {
    async fetchRelayPoints() {
      if (this.relayPointsFetched || this.relayPointsLoading) return;
      const tunnelHelper = new TunnelHelper(this.$http, this.$auth);
      try {
        this.relayPointsLoading = true;
        const data = await tunnelHelper.getRelayPointsByIdAddressAndIdCarrier({
          idAddress: this.idAddressDelivery,
          idCarrier: this.carrier.IdCarrier,
        });

        this.relayPoints = data.RelayPoints;
        this.relayPointsFetched = true;

        if (this.relayPoints) {
          this.relayPointSelected = this.relayPoints[0];
        }

        // this.setCarrier();
      } catch (error) {
        console.log(error);
      } finally {
        this.relayPointsLoading = false;
      }
    },
    selectRelayPoint() {
      this.drawer = true;
      this.mapSelected = 'CarriersMap';
      this.drawerTitle = ' Choisir un relais colis';
    },
    selectRelaitPoint($event) {
      this.relayPointSelected = $event;
      this.choseCarrier();
      this.drawer = false;
    },
    async setCarrier() {
      const params = {
        idCarrier: this.carrier.IdCarrier,
      };
      if (this.relayPointSelected) {
        params.idRelayPoint = this.relayPointSelected.Id;
        params.countryIsoCode =
          this.relayPointSelected?.CountryIsoCode || this.getCarrier?.Country;
      }
      params.idAddress = this.idAddressDelivery;
      params.idAddressInvoice = this.idAddressInvoice;
      try {
        await this.cartService.setCarrierToCart(params);
        await this.cartService.fetchCart();
        if (this.$SETTINGS.isMobile) {
          // this.choseCarrier();
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    isSelected(carrier) {
      if (this.getCarrier) {
        return carrier.IdCarrier === this.getCarrier.IdCarrier;
      }

      return false;
    },
    openMap(carrier) {
      this.pointsClickAndCollectMap = [
        {
          id: 0,
          latitude: carrier?.Attributes?.Lat,
          longitude: carrier?.Attributes?.Long,
        },
      ];
      this.drawer = true;
      this.drawerTitle = carrier.CarrierName + ' - ' + carrier.CarrierTitle;
      this.mapSelected = 'MAP';
    },
    async choseCarrier() {
      try {
        await this.setCarrier();
        this.$router.push(
          this.localePath({
            name: 'cart-payment',
          })
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
    Button,
    Popover,
    Drawer,
    RelaiPointCard,
    ClockIcon,
    ChevronDownIcon,
    MapPinIcon,
    CarriersHoraire,
    Teleport,
    SkeletonItem,
    Skeleton,
  },
};
